import React, { memo } from "react";
import PropTypes from "prop-types";

const RepaymentResults = ({
  aprValue,
  payment,
  totalRepayment,
  termType,
  formatMoney,
}) => {
  return (
    <div className="mrc-results">
      <div className="mrc-results-col">
        <div className="label">Representative</div>
        <div className="value">{aprValue.toFixed(1)}% APR</div>
      </div>
      <div className="mrc-results-col highlight">
        <div className="label">
          {termType === "weeks" ? "Weekly Repayment" : "Monthly Repayment"}
        </div>
        <div className="value value--white">{formatMoney(payment)} *</div>
      </div>
      <div className="mrc-results-col">
        <div className="label">Total Repayment</div>
        <div className="value">{formatMoney(totalRepayment)} *</div>
      </div>
    </div>
  );
};

// Add PropTypes for type checking
RepaymentResults.propTypes = {
  aprValue: PropTypes.number.isRequired,
  payment: PropTypes.number.isRequired,
  totalRepayment: PropTypes.number.isRequired,
  termType: PropTypes.oneOf(["months", "weeks"]).isRequired,
  formatMoney: PropTypes.func.isRequired,
};

// Use memo to prevent unnecessary re-renders
export default memo(RepaymentResults);
